var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isContentVisibleToUser())?_c('grid-fixed',{directives:[{name:"easyadmin",rawName:"v-easyadmin",value:(_vm.easyadminId),expression:"easyadminId"}],key:_vm.resultContent.name,staticClass:"pb-3 pb-md-4",attrs:{"content":_vm.resultContent,"alternative-append-contents":_vm.alternativeAppendContents,"id":`ref-${_vm.easyadminId}`}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }